import { ServerGroupManagerReader } from './ServerGroupManagerReader';
import type { Application } from '../application';
import { ApplicationDataSourceRegistry } from '../application';
import type { IServerGroupManager } from '../domain/IServerGroupManager';
import { EntityTagsReader } from '../entityTag/EntityTagsReader';

export function registerServerGroupManagerDataSource(): void {
  const loader = (application: Application) =>
    ServerGroupManagerReader.getServerGroupManagersForApplication(application.name);

  const onLoad = (_application: Application, serverGroupManagers: IServerGroupManager[]) =>
    Promise.resolve(serverGroupManagers);

  const addTags = (application: Application) => {
    EntityTagsReader.addTagsToServerGroupManagers(application);
  };

  ApplicationDataSourceRegistry.registerDataSource({
    key: 'serverGroupManagers',
    visible: false,
    loader,
    onLoad,
    afterLoad: addTags,
    defaultData: [],
  });
}

registerServerGroupManagerDataSource();
